import React from 'react';
import styled from 'styled-components';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import { media, TransitionMixin } from '../helpers';
import NewLogo from '../../assets/images/logo.svg';
import Menu from '../Menu';
const MobileWrap = styled.div`
	text-align: right;

	${media.large`display: none;`};
`;

const MobileMenuWrap = styled.div`
	background: rgba(34, 34, 34, 0.9);
	height: 100vh;
	width: 100%;
	position: fixed;
	top: 0;
	z-index: 20;
	transform: translateY(100%);
	${TransitionMixin('.25s')};

	&.active {
		transform: translateY(0%);
	}

	> .inner-wrap {
		padding: 100px 30px;

		ul {
			list-style: none;
			padding: 0px;
			text-align: left;

			li {
				margin-bottom: 20px;
				a {
					font-size: 40px;
					font-weight: 300;
				}
			}
		}
	}
`;

const StyledHeader = styled.header`
	text-align: center;
	position: fixed;
	width: 100%;
	z-index: 1000;
	padding: 0px;
	top: 0;
	border-bottom: 1px solid transparent;
	${media.medium``};
	${media.medium`z-index: 1000;`};
	${media.large`padding: 25px 0px;`};
	${media.xl`padding: 50px 0px;`};

	> .inner-wrap {
		display: grid;
		grid-template-columns: 90% 10%;
		max-width: 90vw;
		margin: 0 auto;
		position: relative;
		z-index: 2000;
		${media.medium`grid-template-columns: 50% 50%;`};
	}

	${TransitionMixin('.25s')};

	a {
		color: #fff;
		text-decoration: none;
	}

	.logo-section {
		.logo-wrap {
			text-align: left;
			margin: 0px auto;
			position: relative;
			z-index: 1;

			svg {
				max-width: 200px;
				height: 80px;
				${TransitionMixin('.25s')};
				${media.small`max-width: 300px;`};

				g,
				text {
					fill: #fff;
				}

				text {
					font-family: 'Lato', sans-serif;
				}
			}
		}
	}

	.link-section {
		align-self: center;
		text-align: right;
		ul {
			display: none;
			margin: 0;
			padding: 0px;
			${media.large`display: block;`};

			li {
				display: inline-block;
				margin: 0 15px;

				a {
					font-family: 'Roboto', sans-serif;
					letter-spacing: 1.5px;
					text-transform: uppercase;
					font-size: 13px;
					${TransitionMixin('.25s')};

					&:hover {
						opacity: 0.7;
					}
				}
			}
		}
	}
	&.active {
		background: #fff;
		padding: 0px;
		border-color: #efefef;
		.link-section {
			ul {
				li {
					a {
						color: #777;
					}
				}
			}
		}

		.logo-wrap {
			svg {
				max-width: 260px;
				height: 80px;

				@media (max-width: 325px) {
					max-width: 210px;
				}

				text {
					fill: #313186 !important;
				}

				g {
					fill: #1dc1e5 !important;
				}
			}
		}

		.hamburger-inner,
		.hamburger-inner::before,
		.hamburger-inner::after {
			background-color: #000;
		}
	}
`;

class Header extends React.Component {
	state = {
		inMotion: false,
		mobileMenuOpen: false,
		windowPosition: 0
	};
	componentDidMount = () => {
		this.checkScrollPosition();
		window.addEventListener('scroll', () => {
			this.checkScrollPosition();
			this.setState({
				windowPosition: window.scrollY
			});
		});
	};

	checkScrollPosition = () => {
		console.log('check scroll');

		if (window.scrollY > 50 && !this.state.mobileMenuOpen) {
			this.setState({
				inMotion: true
			});
		} else {
			this.setState({
				inMotion: false
			});
		}
	};

	hamburgerToggle = () => {
		if (document.querySelector('#hamburger').classList.contains('is-active')) {
			this.closeMenu();
			console.log(this.state.mobileMenuOpen);
			if (this.state.windowPosition > 50) {
				this.setState({
					inMotion: true
				});
			}
		} else {
			this.openMenu();
		}
	};

	openMenu = () => {
		document.querySelector('#hamburger').classList.add('is-active');
		document.querySelector('#mobile-menu-wrap').classList.add('active');
		this.setState({
			mobileMenuOpen: true,
			inMotion: false
		});
	};

	closeMenu = () => {
		document.querySelector('#hamburger').classList.remove('is-active');
		document.querySelector('#mobile-menu-wrap').classList.remove('active');
		this.setState({
			mobileMenuOpen: false
		});
	};

	render() {
		return (
			<StyledHeader className={this.state.inMotion ? 'active' : ''}>
				<div className="inner-wrap">
					<div className="logo-section">
						<div className="logo-wrap">
							<Link onClick={this.closeMenu} to="/">
								<NewLogo />
							</Link>
						</div>
					</div>
					<div className="link-section">
						<Menu />
						<MobileWrap>
							<button
								onClick={this.hamburgerToggle}
								className="hamburger hamburger--slider"
								id="hamburger"
							>
								<div className="hamburger-box">
									<div className="hamburger-inner" />
								</div>
							</button>
						</MobileWrap>
					</div>
				</div>
				<MobileMenuWrap id="mobile-menu-wrap">
					<div className="inner-wrap">
						<Menu toggle={this.hamburgerToggle} />
					</div>
				</MobileMenuWrap>
			</StyledHeader>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js